import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { useRole } from '../hooks/useRole';
import { useNavigate } from 'react-router-dom';
import * as Lu from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

export default function DefaultPasswordBanner() {
  const { user } = useAuth();
  const { profile } = useRole();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  // Only show if profile has is_default_password = true
  if (!profile || !profile.is_default_password || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-3 flex items-center justify-between gap-3 shadow-lg">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <SafeIcon icon={Lu.LuShieldAlert} size={18} className="shrink-0" />
        <p className="text-xs font-black uppercase tracking-wide truncate">
          You are using the default password. Please change it immediately in{' '}
          <button
            onClick={() => navigate('/settings')}
            className="underline font-black hover:text-amber-100"
          >
            Settings → Change Password
          </button>
        </p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="shrink-0 p-1 hover:bg-amber-600 rounded-lg transition-colors"
      >
        <SafeIcon icon={Lu.LuX} size={16} />
      </button>
    </div>
  );
}